// extracted by mini-css-extract-plugin
export default {"description":"CobraCensus_description__fNpiu","censusHeading":"CobraCensus_censusHeading__DPTcZ"};